<template>
  <div class="group-container">
    <h2>{{ group.name }}</h2>
    <hotkey-item v-for="item in group.items" :key="itemKey(item.name)" :item="item" v-on:increment-stage="incrementStage" :stage="stageFor(item.name)"/>
  </div>
</template>

<script>
  import HotkeyItem from '@/components/HotkeyItem.vue'

  export default {
    name: "HotkeyGroup",
    components: {
      HotkeyItem
    },
    props: ['group'],
    methods: {
      incrementStage(itemName) {
        this.$store.commit('incrementProgress', this.itemKey(itemName));
      },
      stageFor(itemName) {
        return this.$store.getters.getProgress(this.itemKey(itemName)) || 0;
      },
      itemKey(itemName) {
        return `${this.group.name} :: ${itemName}`;
      }
    }
  }
</script>

<style>
  .group-container {
    width: 450px;
    user-select: none;
  }

  h2 {
    font-weight: 300;
    margin-top: 20px;
    margin-bottom: 10px;
    color: hsl(204, 80%, 25%);
    font-size: 24px;
    text-align: center;
  }
</style>